import React from "react";
import { useNavigate } from "react-router-dom";
import { Avatar, Box, HStack, VStack, Text } from "@chakra-ui/react";
import { IoCallOutline, IoCreateOutline } from "react-icons/io5";
import { MdOutlineGroups } from "react-icons/md";
import { useAuth } from "../context/AuthContext";

const AppFooter = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  // const navigateToNewGroup = () => {
  //   navigate("/chats/group/new");
  // };

  return (
    <Box
      width="100%"
      bg="white"
      p={2}
      borderTop="1px solid"
      borderColor="gray.100"
    >
      <HStack justify="space-around" align="center">
        <VStack
          spacing={1}
          cursor="pointer"
          onClick={() => navigate("/spaces")}
          _hover={{ opacity: 0.7 }}
          py={1}
        >
          <Box fontSize="2xl" color="gray.600">
            <MdOutlineGroups />
          </Box>
          <Text fontSize="xs" color="gray.600" fontWeight="500">
            Spaces
          </Text>
        </VStack>

        <VStack
          spacing={1}
          cursor="pointer"
          onClick={() => navigate("/calls")}
          _hover={{ opacity: 0.7 }}
          py={1}
        >
          <Box fontSize="2xl" color="gray.600">
            <IoCallOutline />
          </Box>
          <Text fontSize="xs" color="gray.600" fontWeight="500">
            Calls
          </Text>
        </VStack>

        <VStack
          spacing={1}
          cursor="pointer"
          onClick={() => navigate("/chats/new")}
          _hover={{ opacity: 0.7 }}
          py={1}
        >
          <Box fontSize="2xl" color="gray.600">
            <IoCreateOutline />
          </Box>
          <Text fontSize="xs" color="gray.600" fontWeight="500">
            New Chat
          </Text>
        </VStack>

        <VStack
          spacing={1}
          cursor="pointer"
          onClick={() => navigate("/settings")}
          _hover={{ opacity: 0.7 }}
          py={1}
        >
          <Avatar
            bg="teal.500"
            color="white"
            name={currentUser.name}
            size="sm"
          />
        </VStack>
      </HStack>
    </Box>
  );
};

export default AppFooter;
